const updatePlaylistDisplayHubStories = (
  update: PlaylistDisplayHubStory[],
  current: PlaylistDisplayHubStory[] | null
) => {
  if (!current) return current;

  const result = current.map((playlistDisplayHubStory) => {
    const updatedPlaylistDisplayHubStory = update.find((p) => p.id === playlistDisplayHubStory.id);
    if (updatedPlaylistDisplayHubStory) {
      return updatedPlaylistDisplayHubStory;
    }
    return playlistDisplayHubStory;
  });

  return result;
};

export { updatePlaylistDisplayHubStories };
